var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{staticClass:"navbar-item",attrs:{"to":"/"}},[_c('div',{staticClass:"site-title"},[_c('site-logo'),_vm._v(" "),_c('site-name')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }